import { action, computed, makeObservable, observable, runInAction } from 'mobx';

import { DeviceInfo } from '../types/device';
import { DbNode } from '../types/node';
import { NodeService } from '../http/node-service';
import { DeviceService } from '../http/device-service';

export default class NodeStore {
    private _nodeId: number;
    private _loading = false;
    private _nodes: DbNode[] = [];
    private _devices: DeviceInfo[] = [];

    constructor(nodeId: number = 0) {
        this._nodeId = nodeId;
        makeObservable<NodeStore, '_loading' | '_nodes' | '_devices'>(this, {
            _loading: observable,
            _nodes: observable,
            _devices: observable,
            loading: computed,
            nodes: computed,
            devices: computed,
            load: action,
            loadNodes: action,
            loadDevices: action,
        });
    }

    get loading(): boolean {
        return this._loading;
    }
    get nodes(): DbNode[] {
        return this._nodes;
    }
    get devices(): DeviceInfo[] {
        return this._devices;
    }

    async load(): Promise<void> {
        await this.loadNodes();
        await this.loadDevices();
    }

    async loadNodes(): Promise<void> {
        runInAction(() => {
            this._loading = true;
        });
        try {
            const answer = await NodeService.getNodes(this._nodeId);
            runInAction(() => {
                this._nodes = answer.data;
            });
        } catch (e) {
            throw e;
        } finally {
            runInAction(() => {
                this._loading = false;
            });
        }
    }

    async loadDevices(): Promise<void> {
        runInAction(() => {
            this._loading = true;
        });
        try {
            const answer = await DeviceService.byNode(this._nodeId);
            runInAction(() => {
                this._devices = answer.data;
            });
        } catch (e) {
            throw e;
        } finally {
            runInAction(() => {
                this._loading = false;
            });
        }
    }
}
